import {useContext} from 'preact/hooks';
import {JSX} from 'preact/jsx-runtime';

import {PropsWithChildren} from 'utilities/props';

import {UiLineType} from '../types';
import {LayoutContext} from '../context';

export function Line({
  children,
  type = UiLineType.Generic,
}: PropsWithChildren<{type?: UiLineType}>) {
  const {lineWrapper} = useContext(LayoutContext);

  if (!children) {
    return null;
  }

  return lineWrapper(type, children) as JSX.Element;
}
